/**
 * Centralized Icon Registry
 *
 * Import and register all Lucide icons used in the application here.
 * This approach provides:
 * - Tree-shaking: Only imported icons are bundled
 * - Centralized management: Add/remove icons in one place
 * - Type safety: JSDoc provides autocomplete for icon names
 * - Easy refactoring: Change icon names or libraries without touching components
 *
 */

import {
  AlertCircle,
  AlertTriangle,
  ArrowLeft,
  ArrowRight,
  Building2,
  Check,
  Clock,
  Copy,
  ExternalLink,
  HelpCircle,
  Mail,
  Menu,
  MonitorSmartphone,
  RefreshCw,
  SearchX,
  Share2,
  WifiOff,
  X,
} from 'lucide-vue-next'

/**
 * Icon Registry Map
 * Maps string names to Lucide icon components
 *
 * Naming convention: Use kebab-case for icon names
 * @type {Record<string, import('vue').Component>}
 */
export const ICON_REGISTRY = {
  'alert-circle': AlertCircle,
  'alert-triangle': AlertTriangle,
  'arrow-left': ArrowLeft,
  'arrow-right': ArrowRight,
  'building-2': Building2,
  check: Check,
  clock: Clock,
  copy: Copy,
  'external-link': ExternalLink,
  'help-circle': HelpCircle,
  mail: Mail,
  menu: Menu,
  'monitor-smartphone': MonitorSmartphone,
  'refresh-cw': RefreshCw,
  'search-x': SearchX,
  'share-2': Share2,
  'wifi-off': WifiOff,
  'x-icon': X,
}

/**
 * Get icon component by name
 * @param {string} name - Icon name (kebab-case)
 * @returns {import('vue').Component | null}
 */
export function getIcon(name) {
  return ICON_REGISTRY[name] || null
}
